(() => {
  if (customElements.get('outfitter-rewards-signup')) return;
  customElements.define('outfitter-rewards-signup', class extends HTMLElement {
    connectedCallback() {
      this.listeners=new AbortController();
      const availabilityHub=document.querySelector('simpson-customer-hub');
      const updateAvailability=()=>{
        const enabled=availabilityHub?.dataset.rewardsEnabled === 'true';
        this.querySelectorAll('[data-or-coming-soon]').forEach(node=>{node.hidden=enabled;});
        this.querySelectorAll('[data-or-active]').forEach(node=>{node.hidden=!enabled;});
        const card=this.querySelector('[data-or-join-card]');
        const title=this.querySelector(enabled?'[data-or-active] h2':'[data-or-coming-soon] h2');
        if(card&&title)card.setAttribute('aria-labelledby',title.id);
      };
      updateAvailability();
      if(availabilityHub) {
        this.availabilityObserver=new MutationObserver(updateAvailability);
        this.availabilityObserver.observe(availabilityHub,{attributes:true,attributeFilter:['data-rewards-enabled']});
      }
      this.addEventListener('click', event=>{
        const link=event.target.closest('[data-or-open-hub], [data-or-continue]');
        if(!link)return;
        const hub=document.querySelector('simpson-customer-hub');
        if(hub?.dataset.rewardsEnabled !== 'true'){event.preventDefault();return;}
        const destination=link.hash === '#simpson-hub-rewards' ? 'loyalty' : 'loyalty-join';
        if(!hub?.querySelector('[data-hub-view="'+destination+'"]'))return;
        event.preventDefault();
        history.replaceState(history.state,'',location.pathname+location.search+link.hash);
        hub.navigate(destination);hub.open();
      },{signal:this.listeners.signal});
    }
    disconnectedCallback(){this.listeners?.abort();this.availabilityObserver?.disconnect();}
  });
})();